import React, { useState } from 'react';

interface DuplicatePlayersBannerProps {
  /** Sum of profileCount across all groups — reads as "N players", matching the design copy. */
  totalProfileCount: number;
  onReviewClick: () => void;
}

const DuplicatePlayersBanner: React.FC<DuplicatePlayersBannerProps> = ({
  totalProfileCount,
  onReviewClick,
}) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || totalProfileCount <= 0) return null;

  return (
    <div className="duplicate-players-banner">
      <div className="duplicate-players-banner__text">
        <div className="duplicate-players-banner__title">
          {totalProfileCount} player{totalProfileCount === 1 ? '' : 's'} look like duplicates
        </div>
        <div className="duplicate-players-banner__description">
          Some player profiles in this league may be the same person registered more than once.
          Review them to merge duplicates and keep stats accurate.
        </div>
      </div>
      <div className="duplicate-players-banner__actions">
        <button type="button" className="duplicate-players-banner__review-btn" onClick={onReviewClick}>
          Review duplicates
        </button>
        <button
          type="button"
          className="duplicate-players-banner__dismiss"
          aria-label="Dismiss"
          onClick={() => setDismissed(true)}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default DuplicatePlayersBanner;
